import type { Validator } from './types';

export function makeRequiredValidator<TValue>(
    message: string = 'Поле обязательное',
): Validator<TValue> {
    return (value: unknown) => (value ? undefined : message);
}
